import React, {useState} from "react";
import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "../helpers/spinner.css";
import {Route, Routes} from "react-router-dom";
import {EmployeeStatus} from "../components/employeeStatus/EmployeeStatus";
import AccountSettingsRoute from "../components/routes/AccountSettingsRoute";
import AuthorizedComponent from "../authorized-component";
import AccountDeleted from "../pages/AccountDeleted";
import MFADeleted from "../pages/MFADeleted";
import NotFound from "../components/notFound/NotFound";
import AdminUpdatePage from "../pages/AdminUpdatePage";


function AuthorizedRoutes() {

    const [alert, setAlert] = useState(null);

    const showAlert = (message, type) => {
        setAlert({
            id: Date.now(),
            msg: message,
            type: type
        });
        setTimeout(() => {
            setAlert(null);
        }, 30000);
    };

    const props = {alert, showAlert};

    return (
        <Routes>
            <Route path="/delete/profile" element={<AccountDeleted />} />
            <Route path="/delete/mfa" element={<MFADeleted />} />
            <Route
                path="/employee-status"
                element={
                    <AuthorizedComponent>
                        <EmployeeStatus />
                    </AuthorizedComponent>
                }
            />

            <Route
                path="/admin/update/profile"
                element={
                    <AuthorizedComponent>
                        <AdminUpdatePage {...props}/>
                    </AuthorizedComponent>
                }
            />

            <Route
                path="/account-settings"
                element={
                    <AuthorizedComponent>
                        <AccountSettingsRoute {...props}/>
                    </AuthorizedComponent>
                }
            />

            <Route
                path="*"
                element={
                    <AuthorizedComponent>
                        <NotFound />
                    </AuthorizedComponent>
                }
            />
        </Routes>
    );
}
export default AuthorizedRoutes;
